var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8505 4.90478L13.2261 3.06288",
    stroke: "#31B59F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4437 8.67621L9.99615 8.42722",
    stroke: "#31B59F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9263 3.09786L19.045 0.64051",
    stroke: "#31B59F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0219 35.0608C29.4331 38.9516 26.7296 41.809 25.5762 42.961C25.2545 43.2824 24.7459 43.2812 24.4255 42.9585C21.9149 40.4303 12.0261 29.7319 12.0261 18.0731C12.0261 14.4999 13.393 11.0732 15.826 8.54658C18.259 6.02 21.5588 4.60059 24.9996 4.60059C28.4404 4.60059 31.7402 6.02 34.1732 8.54658C36.6062 11.0732 37.9731 14.4999 37.9731 18.0731C37.9731 23.1174 36.1543 27.952 33.8787 32.0266",
    stroke: "#35404A",
    strokeWidth: 1.3587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7522 17.8134C29.7522 20.4377 27.6247 22.5652 25.0004 22.5652C22.376 22.5652 20.2485 20.4377 20.2485 17.8134C20.2485 15.189 22.376 13.0615 25.0004 13.0615C27.6247 13.0615 29.7522 15.189 29.7522 17.8134Z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5984 40.7598C38.2138 41.4948 42.072 43.0191 42.072 44.7803C42.072 47.2592 34.4287 49.2687 25.0001 49.2687C15.5716 49.2687 7.92822 47.2592 7.92822 44.7803C7.92822 43.0191 11.7864 41.4948 17.4019 40.7598",
    stroke: "#31B59F",
    strokeWidth: 1.3587,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9995,
    cy: 17.8131,
    rx: 8.16758,
    ry: 8.16759,
    stroke: "#35404A",
    strokeWidth: 1.3587
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f53d3fa29c81ae3b3cb757c55d72e6de.svg";
export { ForwardRef as ReactComponent };